import { BelongsToField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type { TmCountryCode } from '@/services/types'
import Country from '@/data/models/domain/Country'

@OrmModel(modelNames.BILLING_DETAILS)
export default class BillingDetails extends BaseModel {
  @StringField()
  public company: string

  @StringField()
  public accountingEmail: string

  @StringField()
  public paymentCountry: TmCountryCode

  @BelongsToField(Country, 'paymentCountry')
  public paymentCountryEntity: Country

  @StringField()
  public street: string

  @StringField()
  public area: string

  @StringField()
  public state: string

  @StringField()
  public city: string

  @StringField()
  public zip: string
}
